import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './CookieDisclosure.css';

const STORAGE_KEY = 'bodyworks_cookie_disclosure_accepted';

function CookieDisclosure() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') return;
    } catch {
      /* private mode / blocked storage — still show */
    }
    setVisible(true);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  const banner = (
    <div className="cookie-disclosure" role="dialog" aria-label="Cookie notice" aria-live="polite">
      <div className="cookie-disclosure-inner">
        <p className="cookie-disclosure-text">
          We use cookies and similar technologies (including Google Analytics, Google Tag Manager,
          Meta Pixel, Microsoft Clarity, and Firebase) to run the site, measure traffic, and improve
          marketing. By continuing to use this site, you agree to our use of cookies.
        </p>
        <button type="button" className="cookie-disclosure-accept" onClick={accept}>
          Got it
        </button>
      </div>
    </div>
  );

  return createPortal(banner, document.body);
}

export default CookieDisclosure;
